(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    let config;
    try { config = JSON.parse(root.querySelector('[data-ap-config]').textContent); }
    catch (_) { const notice=root.querySelector('[data-ap-status]');if(notice)notice.textContent='The equipment builder could not load. Please call 1-888-792-9315 for a quote.';return; }
    root.dataset.ready = '1';
    const form = root.querySelector('[data-ap-form]');
    const key = 'amc_procurement_v1_' + config.key;
    const productMap = new Map(config.products.map(p => [p.handle, p]));
    const money = n => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(n / 100);
    const configurationLabel = name => name === 'Default Title' ? 'Standard configuration' : name;
    const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const qty = value => Math.min(999, Math.max(1, Math.floor(Number(value) || 1)));
    const get = selector => root.querySelector(selector);
    const field = name => form && form.querySelector('[name="contact[' + name + ']"]');
    const val = name => field(name) ? field(name).value.trim() : '';
    const status = (message, error) => {
      get('[data-ap-status]').textContent = message;
      get('[data-ap-status]').dataset.error = error ? 'true' : 'false';
    };
    const activeCurrency=(window.Shopify && window.Shopify.currency && window.Shopify.currency.active)||config.currency||'USD';
    if (activeCurrency !== 'USD') {
      root.querySelectorAll('button,input,select,textarea').forEach(el=>{el.disabled=true;});
      root.querySelectorAll('[data-ap-price]').forEach(el=>{el.textContent='USD quote required';});
      status('This builder prepares USD equipment quotes. Switch the store currency to USD or call 1-888-792-9315 for pricing.',true);
      return;
    }
    function reference() {
      const bytes = new Uint8Array(6);
      crypto.getRandomValues(bytes);
      return config.prefix + '-' + new Date().toISOString().slice(0,10).replace(/-/g,'') + '-' + Array.from(bytes, n => n.toString(16).padStart(2,'0')).join('').toUpperCase();
    }
    let state = {version:1,ref:reference(),mode:'quote',lines:[]};
    try {
      const saved = JSON.parse(localStorage.getItem(key));
      if (saved && saved.version === 1 && new RegExp('^' + config.prefix + '-[0-9]{8}-[A-F0-9]{12}$').test(saved.ref)) {
        state = {version:1,ref:saved.ref,mode:saved.mode === 'po' ? 'po' : 'quote',lines:Array.isArray(saved.lines) ? saved.lines.slice(0,50).filter(i => /^[a-z0-9-]{1,255}$/.test(i.handle) && /^\d{1,20}$/.test(String(i.id)) && Number.isInteger(i.price) && i.price > 0).map(i => ({...i,qty:qty(i.qty)})) : []};
      }
    } catch (_) {}
    const persist = () => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
    const subtotal = () => state.lines.reduce((sum, line) => sum + line.price * line.qty, 0);
    const locationType = () => val('Location type') === 'Other' ? 'Other: ' + val('Other location type') : val('Location type');
    const vendorText = () => config.vendorName + '\n' + config.address.join('\n') + '\n' + (config.vendor ? 'Supplied vendor number: ' + config.vendor : 'Vendor number: not supplied');
    function draw() {
      get('[data-ap-reference]').textContent = state.ref;
      root.querySelectorAll('[data-ap-count]').forEach(el => { el.textContent = state.lines.length; });
      root.querySelectorAll('[data-ap-subtotal]').forEach(el => { el.textContent = money(subtotal()); });
      get('[data-ap-empty]').hidden = state.lines.length > 0;
      get('[data-ap-lines]').innerHTML = state.lines.map(line =>
        '<li class="ap-line" data-line="' + esc(line.id) + '"><div><h4>' + esc(line.title) + '</h4><p>' +
        esc(line.variant === 'Default Title' ? 'Standard configuration' : line.variant) + (line.sku ? ' · SKU ' + esc(line.sku) : '') +
        '</p><p>' + money(line.price) + ' per selected configuration</p><div class="ap-line-controls"><label>Qty <input aria-label="Quantity of ' + esc(line.title) + '" type="number" value="' + line.qty + '" min="1" max="999" step="1" data-line-qty></label><button type="button" class="ap-remove" data-line-remove>Remove</button></div></div><div class="ap-line-total">' + money(line.price * line.qty) + '</div></li>'
      ).join('');
      root.querySelectorAll('[data-ap-mode]').forEach(btn => btn.setAttribute('aria-pressed', String(btn.dataset.apMode === state.mode)));
      root.querySelectorAll('[data-ap-po-only]').forEach(el => { el.hidden = state.mode !== 'po'; });
      get('[data-ap-document-title]').textContent = state.mode === 'po' ? 'Your customer PO draft' : 'Your equipment quote';
      if (get('[data-ap-submit]')) get('[data-ap-submit]').textContent = state.mode === 'po' ? 'Submit PO draft for review' : 'Request equipment quote';
      if (get('[data-ap-print]')) get('[data-ap-print]').textContent = state.mode === 'po' ? 'Print PO draft' : 'Print equipment quote';
      if (field('Supplier reference')) field('Supplier reference').value = state.ref;
      if (field('Request type')) field('Request type').value = state.mode === 'po' ? 'Customer PO draft / existing PO review' : 'Equipment quote request';
      persist();
    }
    function add(p, variantId, quantity) {
      const variant = p.variants.find(v => String(v.id) === String(variantId));
      if (!variant || !Number.isInteger(variant.price) || variant.price <= 0) { status('This item needs a reviewed price. Describe it in the project notes or contact our equipment desk.', true); return; }
      const old = state.lines.find(line => String(line.id) === String(variant.id));
      if (!old && state.lines.length >= 50) { status('This request has 50 product lines. Describe additional requirements in the project notes.', true); return; }
      if (old) old.qty = qty(old.qty + qty(quantity));
      else state.lines.push({handle:p.handle,id:String(variant.id),title:p.title,variant:variant.title,sku:variant.sku || '',price:variant.price,qty:qty(quantity)});
      draw();
      status(p.title + ' added. Your ' + (state.mode === 'po' ? 'PO draft' : 'quote') + ' now has ' + state.lines.length + ' product lines.');
      root.querySelectorAll('[data-ap-mini-status]').forEach(el => { el.textContent = 'Added to your list · ' + state.lines.length + ' lines'; });
    }
    root.querySelectorAll('[data-ap-card]').forEach(card => {
      const p = productMap.get(card.dataset.handle);
      const select = card.querySelector('select');
      if (!p || !Array.isArray(p.variants) || !select) { const addButton=card.querySelector('[data-ap-add]');if(addButton)addButton.disabled=true;return; }
      const update = () => { const v = p.variants.find(v => String(v.id) === select.value); if (v) card.querySelector('[data-ap-price]').textContent = money(v.price); };
      select.addEventListener('change', update);
      card.querySelector('[data-ap-add]').addEventListener('click', () => add(p, select.value, card.querySelector('input[type=number]').value));
      update();
    });
    get('[data-ap-lines]').addEventListener('change', e => {
      if (!e.target.matches('[data-line-qty]')) return;
      const line = state.lines.find(i => String(i.id) === e.target.closest('[data-line]').dataset.line);
      if (line) {
        line.qty = qty(e.target.value); e.target.value = line.qty;
        e.target.closest('[data-line]').querySelector('.ap-line-total').textContent = money(line.price*line.qty);
        root.querySelectorAll('[data-ap-subtotal]').forEach(el=>{el.textContent=money(subtotal());});
        persist();
      }
    });
    get('[data-ap-lines]').addEventListener('click', e => {
      if (!e.target.closest('[data-line-remove]')) return;
      const id = e.target.closest('[data-line]').dataset.line;
      state.lines = state.lines.filter(i => String(i.id) !== id);
      draw();
    });
    root.querySelectorAll('[data-ap-mode]').forEach(btn => btn.addEventListener('click', () => { state.mode = btn.dataset.apMode === 'po' ? 'po' : 'quote'; draw(); status('Document mode changed. Your product list is unchanged.'); }));
    async function loadProduct(handle, force) {
      if (!/^[a-z0-9-]{1,255}$/.test(handle)) throw Error('Use a valid catalog product.');
      if (config.preview) {
        const p = productMap.get(handle);
        if (!p) throw Error('Private preview uses the included catalog snapshot. Full catalog search activates on the Shopify storefront.');
        return p;
      }
      if (!force && productMap.has(handle)) return productMap.get(handle);
      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw Error('Could not load that product. Try again or describe it in the project notes.');
      const p = await response.json();
      if (!p || p.handle !== handle || !Array.isArray(p.variants)) throw Error('This product could not be verified.');
      productMap.set(p.handle, p);
      return p;
    }
    let searchTimer, searchSequence = 0;
    const searchInput = get('[data-ap-search]');
    const searchResults = get('[data-ap-search-results]');
    function showResults(products) {
      searchResults.hidden = false;
      searchResults.innerHTML = products.length ? products.map(p =>
        '<button type="button" class="ap-search-result" data-result-handle="' + esc(p.handle) + '">' + esc(p.title) + '<span>Select configuration</span></button>'
      ).join('') : '<p class="ap-caption">No matching priced item found. Try a model name, or paste its product URL below.</p>';
    }
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const term = searchInput.value.trim().slice(0,100), seq = ++searchSequence;
      if (term.length < 2) { searchResults.hidden = true; return; }
      searchTimer = setTimeout(async () => {
        try {
          if (config.preview) { showResults(Array.from(productMap.values()).filter(p => p.title.toLowerCase().includes(term.toLowerCase())).slice(0,8)); return; }
          const response = await fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8', {credentials:'same-origin'});
          if (!response.ok) throw Error('Search unavailable. Paste a product URL below.');
          const data = await response.json();
          if (seq !== searchSequence) return;
          showResults((((data.resources || {}).results || {}).products || []).filter(p => /^[a-z0-9-]{1,255}$/.test(p.handle)));
        } catch (error) { if (seq === searchSequence) { searchResults.hidden = false; searchResults.textContent = error.message; } }
      }, 240);
    });
    async function selectSearchProduct(handle) {
      const p = await loadProduct(handle);
      const priced = p.variants.filter(v => Number.isInteger(v.price) && v.price > 0);
      if (!priced.length) throw Error('This product is quote-only. Describe it in the project notes for a reviewed price.');
      const box = get('[data-ap-search-choice]');
      box.hidden = false;
      box.querySelector('[data-choice-title]').textContent = p.title;
      const select = box.querySelector('select');
      select.innerHTML = priced.map(v => '<option value="' + esc(v.id) + '">' + esc(v.title === 'Default Title' ? 'Standard configuration' : v.title) + ' · ' + money(v.price) + '</option>').join('');
      const button = box.querySelector('button');
      button.onclick = () => add(p, select.value, box.querySelector('input').value);
      searchResults.hidden = true;
    }
    searchResults.addEventListener('click', async e => {
      const btn = e.target.closest('[data-result-handle]'); if (!btn) return;
      try { btn.disabled = true; await selectSearchProduct(btn.dataset.resultHandle); }
      catch (error) { status(error.message, true); }
      finally { btn.disabled = false; }
    });
    get('[data-ap-url-add]').addEventListener('click', async () => {
      try {
        const raw = get('[data-ap-url]').value.trim();
        const parsed = new URL(raw, location.origin);
        if (!['http:','https:'].includes(parsed.protocol) || ![location.hostname,'www.mymortuarycooler.com','mymortuarycooler.com'].includes(parsed.hostname)) throw Error('Use a MyMortuaryCooler.com product URL.');
        const match = parsed.pathname.match(/(?:^|\/)products\/([a-z0-9-]+)\/?$/);
        if (!match) throw Error('Paste a product URL ending in /products/product-handle.');
        await selectSearchProduct(match[1]);
        status('Product loaded. Choose its configuration and add it to your list.');
      } catch (error) { status(error.message, true); }
    });
    if (field('Location type')) {
      const updateType = () => { const other = val('Location type') === 'Other'; get('[data-ap-other-type]').hidden = !other; field('Other location type').required = other; if (!other) field('Other location type').value = ''; };
      field('Location type').addEventListener('change', updateType); updateType();
    }
    if (get('[data-ap-use-reference]')) get('[data-ap-use-reference]').addEventListener('click', () => {
      field('Accounting reference').value = config.reference;
      status('Supplied SCI reference copied. Confirm that this coding applies to your specific project before submission.');
    });
    async function verify() {
      if (!state.lines.length) return false;
      const started=JSON.stringify(state);
      let changed = false;
      const fetched = new Map();
      for (const handle of new Set(state.lines.map(i => i.handle))) fetched.set(handle, await loadProduct(handle, true));
      if (JSON.stringify(state)!==started) { status('Your list changed while prices were being checked. Review it, then try again.',true);return false; }
      const verified = state.lines.map(line => {
        const p = fetched.get(line.handle);
        const variant = p.variants.find(v => String(v.id) === String(line.id));
        if (!variant || !Number.isInteger(variant.price) || variant.price <= 0) throw Error(line.title + ' needs a reviewed price. Remove the line and describe it in your notes.');
        if (line.price !== variant.price) changed = true;
        return {...line,price:variant.price,title:p.title,variant:variant.title,sku:variant.sku || '',qty:qty(line.qty)};
      });
      state.lines = verified;
      draw();
      if (changed) { status('One or more catalog prices changed. Your list has been updated. Review the new subtotal, then try again.', true); return false; }
      return true;
    }
    function summary() {
      const lines = [
        config.label + ' | ' + (state.mode === 'po' ? 'CUSTOMER PO DRAFT / REVIEW' : 'EQUIPMENT QUOTE REQUEST'),
        'Supplier request reference: ' + state.ref,
        'Supplier details:\n' + vendorText(),
        'Location type: ' + (locationType() || 'Not supplied'),
        'Operating location: ' + val('Operating location'),
        'Location / branch ID: ' + (val('Location ID') || 'Not supplied'),
        'Requisition / request ID: ' + (val('Requisition ID') || 'Not supplied'),
        'Customer PO number: ' + (val('PO number') || 'Not issued / not supplied'),
        'Project / CEA reference: ' + (val('Project reference') || 'Not supplied'),
        'Buyer / bill-to: ' + (val('Bill to') || 'Not supplied'),
        'Ship-to: ' + (val('Ship to') || 'Not supplied'),
        'Needed-by date (request, not a delivery promise): ' + (val('Needed by') || 'Not supplied'),
        'Request purpose: ' + val('Request purpose'),
        'Contact: ' + val('name') + ' | ' + val('email') + ' | ' + val('phone'),
        ''
      ];
      state.lines.forEach((line, index) => lines.push(
        (index + 1) + '. ' + line.title + ' | ' + configurationLabel(line.variant) + ' | SKU ' + (line.sku || 'not supplied') +
        ' | Variant ' + line.id + ' | Qty ' + line.qty + ' x ' + money(line.price) + ' = ' + money(line.price * line.qty) +
        ' | https://www.mymortuarycooler.com/products/' + line.handle + '?variant=' + line.id
      ));
      lines.push('', 'Equipment-only subtotal (USD): ' + (state.lines.length?money(subtotal()):'To be quoted; no equipment selected'), 'Before eligible discounts. Freight, tax, installation and additional options are not included and are not assumed to be zero.');
      if (!state.lines.length) lines.push('No priced items selected: review the requirements in the project notes.');
      if (config.key === 'sci') lines.push('Customer-entered accounting reference: ' + (val('Accounting reference') || 'Not supplied; applicability not verified'));
      lines.push('Project notes: ' + val('Project details'), 'Contact permission: ' + (field('Contact permission') && field('Contact permission').checked ? 'Requester agrees to contact about this request only.' : 'Not supplied'));
      lines.push('Supplier review request only. Not corporate approval, an issued corporate PO, supplier order acceptance or authorization to ship.');
      return lines.join('\n');
    }
    function printDocument() {
      let paper = document.querySelector('body > .ap-print');
      if (!paper) { paper = document.createElement('section'); paper.className = 'ap-print'; document.body.appendChild(paper); }
      const rows = state.lines.map(i => '<tr><td>' + esc(i.title) + '<br><small>' + esc(configurationLabel(i.variant)) + (i.sku ? ' · ' + esc(i.sku) : '') + '<br>Variant ' + esc(i.id) + '</small></td><td>' + i.qty + '</td><td class="ap-print-money">' + money(i.price) + '</td><td class="ap-print-money">' + money(i.price * i.qty) + '</td></tr>').join('');
      paper.innerHTML = '<img src="' + esc(config.logo) + '" alt="American Mortuary Coolers and Equipment"><h1>' + (state.mode === 'po' ? 'CUSTOMER PURCHASE-ORDER DRAFT' : 'EQUIPMENT QUOTE WORKSHEET') +
        '</h1><p>' + esc(config.name) + ' location request · ' + esc(state.ref) + '<br>' + new Date().toLocaleDateString('en-US') + ' · USD</p><div class="ap-print-supplier">' + esc(vendorText()) +
        '</div><p><strong>Operating location:</strong> ' + esc(val('Operating location') || 'Not supplied') + '<br><strong>Type:</strong> ' + esc(locationType() || 'Not supplied') +
        '<br><strong>Contact:</strong> ' + esc(val('name') || 'Not supplied') + ' · ' + esc(val('email')) + '<br><strong>Location ID:</strong> ' + esc(val('Location ID') || 'Not supplied') +
        '<br><strong>Requisition:</strong> ' + esc(val('Requisition ID') || 'Not supplied') + '<br><strong>Customer PO:</strong> ' + esc(val('PO number') || 'DRAFT / not issued') +
        '<br><strong>Project reference:</strong> ' + esc(val('Project reference') || 'Not supplied') + '</p><p><strong>Bill-to:</strong><br>' + esc(val('Bill to') || 'Not supplied').replace(/\n/g,'<br>') +
        '</p><p><strong>Ship-to:</strong><br>' + esc(val('Ship to') || 'Not supplied').replace(/\n/g,'<br>') + '</p><table><thead><tr><th>Equipment / configuration</th><th>Qty</th><th class="ap-print-money">Unit price</th><th class="ap-print-money">Line total</th></tr></thead><tbody>' +
        rows + '</tbody></table><p style="text-align:right"><strong>Equipment-only subtotal: ' + money(subtotal()) + '</strong></p><p>Before eligible discounts. Freight, tax, installation and additional options are not included; none is assumed to be zero.</p><p><strong>Project notes:</strong><br>' +
        esc(val('Project details') || 'None supplied').replace(/\n/g,'<br>') + '</p>' + (config.key === 'sci' && val('Accounting reference') ? '<p><strong>Customer-entered accounting reference:</strong><br>' + esc(val('Accounting reference')) + '<br>Applicability must be confirmed internally.</p>' : '') +
        '<p><strong>' + (state.mode === 'po' ? 'DRAFT ONLY. Not an issued corporate PO or accepted supplier order.' : 'Budgetary website-pricing worksheet. Not a final freight-inclusive supplier quotation.') +
        '</strong></p><small>Subject to configuration, availability, price and freight review. This independent supplier document does not authorize corporate spending or shipment. Contact 1-888-792-9315.</small>';
      window.print();
    }
    get('[data-ap-print]').addEventListener('click', async function () {
      if (!state.lines.length) { status('Add at least one priced product before printing.', true); return; }
      this.disabled = true;
      try { if (await verify()) printDocument(); }
      catch (error) { status(error.message + ' No document was issued.', true); }
      finally { this.disabled = false; }
    });
    get('[data-ap-copy]').addEventListener('click', async () => {
      try { if(state.lines.length && !(await verify()))return;await navigator.clipboard.writeText(summary()); status('Equipment list and references copied. No request was sent.'); }
      catch (error) { status(error.message || 'The list could not be copied. Try again or call the equipment team.', true); }
    });
    let validating=false;
    if (form) form.addEventListener('submit', async e => {
      if (form.dataset.apSend === '1') { delete form.dataset.apSend;return; }
      e.preventDefault();
      if(validating)return;
      if (!form.reportValidity()) return;
      if (!state.lines.length && !val('Project details')) { status('Add priced equipment or describe the items you need in the project notes.', true); return; }
      const submit = get('[data-ap-submit]');
      submit.disabled = true;
      validating=true;
      try {
        if (state.lines.length && !(await verify())) return;
        if (!form.reportValidity()) return;
        field('body').value = summary();
        field('Subject').value = config.label + ' | ' + (state.mode === 'po' ? 'PO review' : 'Quote request') + ' | ' + state.ref;
        if (config.preview) { status('Private preview only: validation passed, but no request was sent. Production submissions use the Shopify contact form on your store.'); return; }
        const receiptData={ref:state.ref,mode:state.mode,at:Date.now(),key:config.key};
        // Remain disabled until the separately staged email integration is approved.
        if(config.confirmationEmailEnabled===true)Object.assign(receiptData,{
          email:val('email'),name:val('name'),
          location:val('Operating location'),locationType:locationType(),locationID:val('Location ID'),
          requisition:val('Requisition ID'),po:val('PO number'),project:val('Project reference'),
          accounting:val('Accounting reference'),purpose:val('Request purpose'),neededBy:val('Needed by'),
          shipTo:val('Ship to'),billTo:val('Bill to'),notes:val('Project details'),subtotal:state.lines.length?money(subtotal()):'To be quoted',
          lines:state.lines.map(line=>({Product:line.title,Configuration:configurationLabel(line.variant),SKU:line.sku,Quantity:line.qty,UnitPrice:money(line.price),LineTotal:money(line.price*line.qty)}))
        });
        try { sessionStorage.setItem(key + '_receipt', JSON.stringify(receiptData)); } catch (_) {}
        form.dataset.apSend = '1';
        // Native Shopify contact submission, including Shopify's anti-spam controls.
        if (form.requestSubmit) form.requestSubmit();
        else HTMLFormElement.prototype.submit.call(form);
      } catch (error) { status(error.message + ' Your request was not sent.', true); }
      finally { validating=false;submit.disabled = false; }
    });
    if (form && form.querySelector('[data-ap-fields]')) form.querySelector('[data-ap-fields]').disabled = false;
    const receipt = get('[data-ap-receipt]');
    if (receipt) {
      try {
        const pending = JSON.parse(sessionStorage.getItem(key + '_receipt'));
        const age=pending && Date.now()-pending.at;
        if (pending && pending.key === config.key && Number.isFinite(age) && age>=0 && age<1800000 && new RegExp('^'+config.prefix+'-[0-9]{8}-[A-F0-9]{12}$').test(pending.ref||'')) {
          receipt.textContent = pending.ref;
          // Request-service confirmation only, gated on Shopify's rendered success state.
          // No marketing subscription or SMS is created, and preview cannot emit it.
          const privacy = window.Shopify && window.Shopify.customerPrivacy;
          const trackingAllowed = !(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed());
          const dedupeKey = key + '_email_queued_' + pending.ref;
          const retainReceipt=()=>sessionStorage.setItem(key+'_receipt',JSON.stringify({key:config.key,ref:pending.ref,mode:pending.mode,at:pending.at}));
          const previousAttempt=sessionStorage.getItem(dedupeKey);
          const inFlight=previousAttempt && previousAttempt!=='1' && Date.now()-Number(previousAttempt)<30000;
          if (config.confirmationEmailEnabled===true && !config.preview && trackingAllowed && pending.email && previousAttempt!=='1' && !inFlight) {
            const props = {
              '$event_id':pending.ref,Reference:pending.ref,CorporateKey:config.key,CorporateName:config.name,
              FormKind:'Corporate equipment request',SubmissionConfirmed:true,IsTest:false,Handled:true,
              SmsConsent:false,EmailConsent:false,Code:pending.mode === 'po'?'PO':'QUOTE',
              RequestLabel:pending.mode === 'po'?'PO review request':'equipment quote request',
              BuyerName:pending.name,BuyerEmail:pending.email,Location:pending.location,
              LocationType:pending.locationType,LocationID:pending.locationID,Requisition:pending.requisition,
              PONumber:pending.po,Project:pending.project,AccountingReference:pending.accounting,
              Purpose:pending.purpose,NeededBy:pending.neededBy,ShipTo:pending.shipTo,BillTo:pending.billTo,ProjectNotes:pending.notes,Items:pending.lines||[],
              Subtotal:pending.subtotal,VendorNumber:config.vendor||'Not supplied',SupplierName:config.vendorName,
              Page:location.pathname,ViewURL:location.origin+location.pathname,ViewLabel:'Return to your equipment desk'
            };
            const profile = {email:pending.email,first_name:(pending.name||'').split(/\s+/)[0]||''};
            try {
              if (window.klaviyo && typeof window.klaviyo.track === 'function') {
                sessionStorage.setItem(dedupeKey,String(Date.now()));
                Promise.resolve(window.klaviyo.identify(profile)).then(()=>window.klaviyo.track('Submitted Desk Request',props)).then(()=>{sessionStorage.setItem(dedupeKey,'1');retainReceipt();}).catch(()=>{sessionStorage.removeItem(dedupeKey);});
              } else {
                window._learnq=window._learnq||[];
                window._learnq.push(['identify',profile]);
                window._learnq.push(['track','Submitted Desk Request',props]);
                sessionStorage.setItem(dedupeKey,'1');
                retainReceipt();
              }
            } catch (_) { sessionStorage.removeItem(dedupeKey); }
          } else if (config.confirmationEmailEnabled!==true || !pending.email || !trackingAllowed || config.preview || previousAttempt==='1') {
            retainReceipt();
          }
          // Uses Shopify's rendered success state plus a company-specific pending receipt.
          // This client bridge is not a signed server-to-server confirmation.
          if (state.ref === pending.ref) { state = {version:1,ref:reference(),mode:'quote',lines:[]}; persist(); }
        } else if(pending) sessionStorage.removeItem(key+'_receipt');
      } catch (_) {}
    }
    draw();
    if(state.lines.length && !config.preview){
      verify().catch(error=>status(error.message+' Saved prices could not be refreshed. No document was issued.',true));
    }
    // Narrow testing/extension API: no customer contact data or cross-organization state.
    root.apPortal = {key:config.key,getState:() => JSON.parse(JSON.stringify(state)),getSubtotal:subtotal,summary:summary};
  }
  function boot(scope) { scope.querySelectorAll('[data-ap-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
